import { useEffect, useState } from "react";

import { IS_DEV } from "@/data/constants";

import { PosthogService } from "../index";

/**
 * Flags arrive over the network. If that request is blocked (ad blockers) or
 * slow, stop waiting so the caller can fall back to its default variant
 * instead of holding a loading state forever.
 */
const FLAG_TIMEOUT_MS = 2500;

type TExperiment = {
  variant: string | boolean | undefined;
  isResolved: boolean;
};

export const useExperiment = (flagKey: string): TExperiment => {
  const [state, setState] = useState<TExperiment>(() => {
    const variant = PosthogService.getFeatureFlag(flagKey);
    return { variant, isResolved: IS_DEV || variant !== undefined };
  });

  useEffect(() => {
    if (IS_DEV) return;

    const unsubscribe = PosthogService.onFeatureFlags?.(() => {
      setState({
        variant: PosthogService.getFeatureFlag(flagKey),
        isResolved: true,
      });
    });

    const timeoutId = setTimeout(
      () => setState((prev) => ({ ...prev, isResolved: true })),
      FLAG_TIMEOUT_MS,
    );

    return () => {
      clearTimeout(timeoutId);
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, [flagKey]);

  return state;
};

export default useExperiment;
